import React from "react";

export default function CopyTypeComponent({ name, handleChange, handleReset }) {
  return (
    <div className="flex items-center">
      <label className="text-sm font-medium text-gray-900 dark:text-gray-300">
        <input
          defaultChecked
          onChange={handleChange}
          value={"HARD_COPY"}
          name={name}
          type="radio"
          className="checkbox-round mr-2 leading-tight"
          // onClick={handleReset}
        />
        <span className="text-sm font-medium">Hard Copy </span>
      </label>
      <label className="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">
        <input
          onChange={handleChange}
          value={"SOFT_COPY"}
          name={name}
          type="radio"
          className="checkbox-round mr-2 leading-tight"
          // onClick={handleReset}
        />
        <span className="text-sm font-medium">Soft copy</span>
      </label>
    </div>
  );
}
